export default __webpack_public_path__ + "static/media/event1.35357d90.png";